// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '';
const ROOTS_AUTH = '/auth';
// ----------------------------------------------------------------------


export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
};



export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    dashboardHome: path(ROOTS_DASHBOARD, '/'),
    coachBookingsDash: path(ROOTS_DASHBOARD, '/coachbookings'),
    incoming: path(ROOTS_DASHBOARD, '/return'),
    schoolTaxiBookings: path(ROOTS_DASHBOARD, '/schooltaxibookings'),
    trackTaxi:path(ROOTS_DASHBOARD, '/tracktaxi/:taxiId'),
    outgoing: path(ROOTS_DASHBOARD, '/leave'),
    reportingPage: path(ROOTS_DASHBOARD, '/reporting'),
    travelDayReporting: path(ROOTS_DASHBOARD, '/tdayreporting/:travelDayId'),
    configPage: path(ROOTS_DASHBOARD, '/config'),
    studentPage: path(ROOTS_DASHBOARD, '/student/:studentId'),
    schoolPage: path(ROOTS_DASHBOARD, '/school/:schoolId'),
  },
  app: {

  }
};
